module.exports = __webpack_public_path__ + "img/refresh.02c87e93.svg";